export default "__VITE_ASSET__BxBPgR7E__"